import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  logoutEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  logout() {
    this.logoutEvent.emit();
  }
}